import React from 'react';

export function ErrorBanner({ children }) {
  if (!children) return null;
  return (
    <div className="flex items-start gap-2 bg-red-50 text-red-700 px-3.5 py-2.5 rounded-xl mb-3 text-[13px] font-bold">
      <span className="shrink-0">⚠️</span>
      <span>{children}</span>
    </div>
  );
}

export function Badge({ children, tone = 'brand', className = '' }) {
  const tones = {
    brand: 'bg-brand-light text-brand-dark',
    gold: 'bg-gold-light text-gold',
    danger: 'bg-red-50 text-red-600',
    info: 'bg-sky-50 text-sky-700',
    neutral: 'bg-black/5 text-ink-soft',
  };
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] font-extrabold px-2 py-0.5 rounded-full ${tones[tone] || tones.brand} ${className}`}>
      {children}
    </span>
  );
}

export function EmptyState({ icon = '📦', title, sub, action }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6">
      <div className="text-5xl mb-3">{icon}</div>
      <div className="font-extrabold text-ink text-[15px]">{title}</div>
      {sub ? <div className="text-ink-faint text-sm mt-1.5 max-w-xs leading-relaxed">{sub}</div> : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}

export function Spinner({ className = '' }) {
  return <span className={`inline-block h-5 w-5 rounded-full border-2 border-brand-light border-t-brand animate-spin ${className}`} />;
}

export function SkeletonCard() {
  return (
    <div className="rounded-2xl border border-black/5 bg-white overflow-hidden animate-pulse">
      <div className="aspect-square bg-brand-light/60" />
      <div className="p-3 space-y-2">
        <div className="h-3 bg-black/10 rounded w-4/5" />
        <div className="h-3 bg-black/10 rounded w-2/5" />
        <div className="h-8 bg-black/10 rounded-lg mt-2" />
      </div>
    </div>
  );
}

export function Toast({ message }) {
  if (!message) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed left-1/2 -translate-x-1/2 bottom-24 md:bottom-8 z-[500] bg-ink text-white text-sm font-bold px-4 py-2.5 rounded-full shadow-lift animate-slideUp"
    >
      ✅ {message}
    </div>
  );
}
